import Twitter_icon from "./../../assets/images/svg/twitter_icon.svg";
import Facebook_icon from "./../../assets/images/svg/facebook_icon.svg";
import { useParams } from "react-router-dom";
import { obraDTO } from "../../models/Colecciones.model";
import { useEffect, useState } from "react";
import axios from "axios";
import { pathImages, webApiObra } from "../../routes/endpoints";
import BotonesAccion from "./Botones_accion";
import Sin_imagen from "../../assets/images/sin_imagen.png";
import { base_url_completa, base_url_completa_codificada } from "../../constants";

export default function Informacion() {
    
    const { id } = useParams() as { id: any; }
    const [obra, setObra] = useState<obraDTO[]>([]);
    let apa = '';
    useEffect(()=>{  
        window.scrollTo(0, 0)
        axios.post(webApiObra, { id:id  } ).then((response) => {  
            setObra(response.data);                                                    
        }).catch(err => console.warn(err));          
    },[id]) 

    if(obra.length){  
        apa = `${Object.values(obra)[0].titulo}` 
        apa = `${apa}\r\nEdición: ${Object.values(obra)[0].edicion}`
        return(
        <div className="container mt-5"> 
            <div className="row">
                <div className="col-12 col-lg-5">
                    <div className="row">
                        <div className="col-12 books_container_obras d-flex justify-content-center align-items-center">
                            { (Object.values(obra)[0].imagen === '' || Object.values(obra)[0].imagen === null) ? <img src={`${Sin_imagen}`} alt="sin_imagen" className="img-fluid px-3 px-sm-0 book_principal"/> 
                        : <img src={`${pathImages}${Object.values(obra)[0].imagen}`} alt="obra" className="img-fluid px-3 px-sm-0 book_principal"/> }
                        </div>
                    </div>
                </div>
            <div className="col-12 col-lg-7">
                <div className="row d-flex">
                    <div className="row">
                        <div className="col-12">
                            <h4 className="text-center text-sm-start text_title_book mt-2 mt-lg-0" dangerouslySetInnerHTML={{__html: `${Object.values(obra)[0].titulo}` }} ></h4>
                        </div>
                    </div>                    
                    <div className="col-md-9 information_books mt-2">
                                <div className="mt-2">
                                    <div className="row">
                                        <div className="col-sm-5 text-center text-sm-end">
                                            <p className="fw-bold">Edición:</p>
                                        </div>
                                        <div className="col-sm-7 text-center text-sm-start">
                                            <p className="synopsis_text" dangerouslySetInnerHTML={{__html: `${Object.values(obra)[0].edicion}` }}/>
                                        </div>
                                    </div>
                                    {(localStorage.getItem('seccion')!=='Novedades /')&&
                                        (Object.values(obra)[0].anio > 0)?
                                            (apa = `${apa}\r\nAño: ${Object.values(obra)[0].anio}`)&&
                                            <div className="row mt-3 mt-sm-0">
                                                <div className="col-sm-5 text-center text-sm-end">
                                                    <p className="fw-bold">Año de publicación:</p>
                                                </div>
                                                <div className="col-sm-7 text-center text-sm-start">
                                                    <p>{Object.values(obra)[0].anio}</p>
                                                </div>
                                            </div>:''
                                    }
                                    {(Object.values(obra)[0].pagina?.length)?
                                        (apa = `${apa}\r\nPáginas: ${Object.values(obra)[0].pagina}`)&&
                                        <div className="row mt-3 mt-sm-0">
                                            <div className="col-sm-5 text-center text-sm-end">
                                                <p className="fw-bold">Páginas:</p>
                                            </div>
                                            <div className="col-sm-7 text-center text-sm-start">
                                                <p>{Object.values(obra)[0].pagina}</p>
                                            </div>
                                        </div>:''}
                                    {(Object.values(obra)[0].coleccion?.length)?
                                        (apa = `${apa}\r\Colección: ${Object.values(obra)[0].coleccion}`)&&
                                        <div className="row mt-3 mt-sm-0">
                                            <div className="col-sm-5 text-center text-sm-end">
                                                <p className="fw-bold">Colección:</p>
                                            </div>
                                            <div className="col-sm-7 text-center text-sm-start">
                                                <p className="synopsis_text" dangerouslySetInnerHTML={{__html: `${Object.values(obra)[0].coleccion}` }}/>
                                            </div>
                                        </div>:''}
                                    {(Object.values(obra)[0].isbnImpresa?.length)?
                                        (apa = `${apa}\r\nISBN impresa: ${Object.values(obra)[0].isbnImpresa}`)&&
                                        <div className="row mt-3 mt-sm-0">
                                            <div className="col-sm-5 text-center text-sm-end">
                                                <p className="fw-bold">ISBN impresa:</p>
                                            </div>
                                            <div className="col-sm-7 text-center text-sm-start">
                                                <p>{Object.values(obra)[0].isbnImpresa}</p>
                                            </div>
                                        </div>:''}
                                    {(Object.values(obra)[0].isbnDigital?.length)?
                                        (apa = `${apa}\r\nISBN digital: ${Object.values(obra)[0].isbnDigital}`)&&
                                        <div className="row mt-3 mt-sm-0">
                                            <div className="col-sm-5 text-center text-sm-end">
                                                <p className="fw-bold">ISBN digital:</p>
                                            </div>
                                            <div className="col-sm-7 text-center text-sm-start">
                                                <p>{Object.values(obra)[0].isbnDigital}</p>
                                            </div>
                                        </div>:''}
                                    {(Object.values(obra)[0].coordinadores?.length)?
                                    <div className="row mt-3 mt-sm-0">
                                        <div className="col-sm-5 text-center text-sm-end">
                                            <p className="fw-bold">{Object.values(obra)[0].etiquetaCoordinador}:</p>
                                        </div>
                                        <div className="col-sm-7 text-center text-sm-start">
                                            <p className="synopsis_text" dangerouslySetInnerHTML={{__html: `${Object.values(obra)[0].coordinadores.replaceAll('&lt;', '<').replaceAll('&gt;', '>')}` }}/>
                                        </div>
                                    </div>:''}
                                    {(Object.values(obra)[0].autores?.length)?
                                        (apa = `${apa}\r\nAutorías: ${Object.values(obra)[0].autores}`)&&                                    
                                        <div className="row mt-3">
                                            <div className="col-sm-5 text-center text-sm-end">
                                                <p className="fw-bold">{Object.values(obra)[0].etiquetaAutor}:</p>
                                            </div>
                                            <div className="col-sm-7 text-center text-sm-start">
                                                <p className="synopsis_text" dangerouslySetInnerHTML={{__html: `${Object.values(obra)[0].autores.replaceAll('&lt;', '<').replaceAll('&gt;', '>')}` }}/>
                                            </div>
                                        </div>:''}    
                                    {(Object.values(obra)[0].colaboradores?.length)?
                                    <div className="row mt-3 mt-sm-0">
                                        <div className="col-sm-5 text-center text-sm-end">
                                            <p className="fw-bold">{Object.values(obra)[0].etiquetaColaborador}:</p>
                                        </div>
                                        <div className="col-sm-7 text-center text-sm-start">
                                            <p className="synopsis_text" dangerouslySetInnerHTML={{__html: `${Object.values(obra)[0].colaboradores.replaceAll('&lt;', '<').replaceAll('&gt;', '>')}` }}/>
                                        </div>
                                    </div>:''}
                                </div>
                            </div>
                            <div className="col-md-3 mt-2">
                                <div className="row d-flex align-items-end h-100">                            
                                    <div className="col-12 text-center btn_social_media d-none d-md-flex align-items-center justify-content-center mt-3">
                                        <div>
                                            <a href={`https://twitter.com/intent/tweet?text=Revisa la obra compartida a través del sitio Editorial&url=${base_url_completa_codificada}%2Fobras%2F${id}&lang=es&via=TEPJF_informa`} target="_blank" className="icon_facebook d-block"><img src={Twitter_icon} className="icon_socialmedia"/>Twitter</a>
                                            <a href={`http://www.facebook.com/sharer.php?u=${base_url_completa}/obras/${id}`} target="_blank" className="icon_twitter d-block mt-2"><img src={Facebook_icon} className="icon_socialmedia"/>Compartir</a>
                                        </div>
                                    </div>
                                    <div className="col-12 px-0 mt-1">
                                        <BotonesAccion id={id} archivo={Object.values(obra)[0].archivo} tipo={1} apa={apa}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-5 mt-2">
                        <div className="row">     
                            <BotonesAccion id={id} archivo={Object.values(obra)[0].archivo} tipo={2} apa={`${Object.values(obra)[0].titulo} ${Object.values(obra)[0].edicion}`}/>
                        </div>
                    </div> 
                    <div className="col-lg-7 mt-2 ps-0 ps-lg-2 pe-0">
                        <div className="back_synopsis">
                            <div className="container_synopsis">
                                <h5>Sinopsis</h5>
                                <p className="synopsis_text" dangerouslySetInnerHTML={{__html: `${Object.values(obra)[0].sinopsis}` }}/> 
                            </div>                            
                        </div>
                        {/* <div className="row d-block d-md-none">
                            <div className="col-md-3 align-self-end d-flex flex-column px-0 mt-4">
                                <div className="row mt-4 mb-3 order-2 mx-0">
                                    <div className="col-12 text-center">
                                        <p className="mb-1">Compartir en:</p>
                                        <img alt="icon_twitter" src={Twitter_icon} className="icon_socialmedia"/>
                                        <img alt="icon_facebook" src={Facebook_icon} className="icon_socialmedia"/>
                                        <CopyToClipboard text={`${base_url_completa}/obras/${id}`}> 
                                            <img alt="icon_copiado" src={Link_icon} className="icon_socialmedia cursor" onClick={ () =>Alertas('Ruta copiada correctamente')}/>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                                <BotonesAccion id={id} archivo={Object.values(obra)[0].archivo} tipo={2}/>
                            </div>
                        </div>  */}
                    </div>
                </div>
            </div>
        )
    }else{
        return(
            <div className="container mt-4 ">
                <div className="row"> No se encuentra disponible la información para el título seleccionado </div>
            </div>
        )
    }
}